const pad = (n) => String(n).padStart(2, "0");

// "YYYY-MM-DD" or ISO datetime -> "MM/DD/YYYY"
export const fmtDate = (v) => {
  if (!v) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v).slice(0, 10));
  if (m && String(v).length <= 10) return `${m[2]}/${m[3]}/${m[1]}`;
  const d = new Date(v);
  return isNaN(d) ? String(v) : `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
};

export const fmtDateTime = (v) => {
  if (!v) return "";
  const d = new Date(v);
  return isNaN(d) ? String(v) : `${fmtDate(v)} · ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
};

// "MM/DD/YYYY" -> "YYYY-MM-DD" (or null if incomplete/invalid)
export const usToIso = (s) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || "");
  if (!m) return null;
  const [mm, dd, yyyy] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const d = new Date(yyyy, mm - 1, dd);
  if (d.getFullYear() !== yyyy || d.getMonth() !== mm - 1 || d.getDate() !== dd) return null;
  return `${m[3]}-${m[1]}-${m[2]}`;
};
